/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this); // SELECTORS

    _this.popUp = document.querySelector('.video-popup-container');
    _this.popUpVideo = _this.popUp.querySelector('.video-container'); // video inside of popup

    _this.openButton = _this.querySelector('.btn-open');
    _this.closeButton = _this.popUp.querySelector('.btn-close');
    _this.playButton = _this.querySelector('.play-btn'); // ENABLE EXTERNAL POPUP ELEMENT

    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    } // SETUP EVENT LISTENERS


    _this._attachListeners();

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this));
      this.playButton.addEventListener('click', this.openPopup.bind(this)); // click outside

      this.popUp.addEventListener('click', this.closePopup.bind(this));
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-thumbnail', EdVideoThumbnail);

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-popup', EdVideoPopup);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;